import axios from "../axios";

const create = (data) => {
  return axios.post("/registered-offices", data);
};

const update = ({ registeredOfficeId, data }) => {
  return axios.put(`/registered-offices/${registeredOfficeId}`, data);
};

const registeredOfficeDataService = {
  create,
  update,
};

export default registeredOfficeDataService;
